import React from "react"
import { Grid, TextField, ListItem, ListItemText } from "@material-ui/core"
import { Autocomplete } from "@material-ui/lab"
import { createFilterOptions } from "@material-ui/lab/Autocomplete"
import * as Adm from "@adm"
import DigitTable from "./DigitTable"
import DigitImageTable from "./DigitImageTable"
import { VendorSwaperLens } from "@iconsGallery"

const EmptyProductStyles = { fontWeight: "500", fontSize: "17px" }
const EmptyProductImage = { display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", marginTop: "30%" }


const renderFieldItemId = (props) => {
  const {
    setCurrentVendorItem = () => "",
    getCurrentVendorItem = [],
    getVendorOpen,
    setVendorOpen,
    classes,
    getToVendorList,
    getToVendorIdList
  } = props


  const renderOptions = (option, props) => {
    let itemId = props
    const [_productItemKit] = getToVendorList.filter((itm) =>
      itm.company_id.includes(itemId)
    )
    const {
      company_name = "",
      company_logo_url = "",
      company_id = "",
    } = _productItemKit
    return (
      <ListItem
        style={{
          paddingLeft: "0px",
        }}
      >
        <img
          src={company_logo_url || "/static/img/noproducts.png"}
          alt={company_name}
          style={{
            width: "100%",
            height: "auto",
            marginRight: 5,
            maxWidth: 70,
            maxHeight: 70,
            minWidth: 70,
            minHeight: 70,
          }}
        />
        <ListItem
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "start",
            alignItems: "start",
            width: "fit-content",
            paddingTop: 0,
            paddingBottom: 0,
          }}
        >
          <ListItemText
            primary={`Vendor: ${company_name}`}
            primaryTypographyProps={{
              style: {
                textOverflow: "ellipsis",
                overflow: "hidden",
                display: "inline-block",
                whiteSpace: "nowrap",
                fontWeight: "bold",
                margin: 0,
              },
            }}
            style={{ margin: 0 }}
          />

          <ListItemText
            style={{ margin: 0 }}
            primary={`Vendor Id : ${company_id}`}
            primaryTypographyProps={{
              style: {
                textOverflow: "ellipsis",
                overflow: "hidden",
                display: "inline-block",
                whiteSpace: "nowrap",
                margin: 0,
              },
            }}
          />
        </ListItem>
      </ListItem>
    )
  }
  const filterOptions = createFilterOptions({
    stringify: (name) => {
      let itemId = name
      const [_productItemKit] = getToVendorList.filter((itm) =>
        itm.company_id.includes(itemId)
      )
      const { company_name = "", company_id = "" } = _productItemKit
      return `${company_name} ${itemId} ${company_id}`
    },
  })

  return (
    <Grid>
      <Autocomplete
        className={`cls-field-form-kit`}
        classes={{ option: classes.option }}
        renderOption={(props, option) => renderOptions(option, props)}
        filterSelectedOptions={true}
        filterOptions={filterOptions}
        options={getToVendorIdList}
        onChange={(e, val) => {
          setCurrentVendorItem([val])
          setVendorOpen(false)
        }}
        open={getVendorOpen}
        disableClearable={true}
        value={getCurrentVendorItem.length > 0 ? getCurrentVendorItem[0] : ""}
        onOpen={(e) => {
          setVendorOpen(true)
        }}
        onClose={(e) => {
          setVendorOpen(false)
        }}

        renderInput={(params) => {
          return (
            <TextField
              {...params}
              variant="outlined"
              className={classes.autoCompleteHeight}
              placeholder="Select the Vendor"
            />
          )
        }}
      />
    </Grid>
  )
}

export const renderHeader = (props) => {
  const {
    getCurrentImageList,
    getCurrentVendorItem = [],
    handleSwapVendor = () => "",
    getSelectedItem = [],
    isWriteAllowed = false,
  } = props || {}

  const selectAllBtnAttr = {
    variant: "contained",
    color: "primary",
    className: `cls-button-kit ${getCurrentVendorItem?.length === 0 || getSelectedItem?.length === 0 ? "cls-disabled" : ""}`,
    onClick: handleSwapVendor,
    disabled: getCurrentVendorItem?.length === 0 || getSelectedItem?.length === 0 || !isWriteAllowed ? true : false,
  }

  return (
    <div className="cls-main-header-kit">
      <div
        style={{ fontSize: 20, fontWeight: "bold" }}
      >{`Storage Name`}</div>
      <div
        style={{ display: "flex" }}
        className={`cls-header-right-kit ${getSelectedItem.length > 0
          ? ""
          : "cls-selected-storage-list-kit-disable"
          }`}
      >
        {renderFieldItemId(props)}
        <Adm.Button {...selectAllBtnAttr}>{"Swap Vendor"}</Adm.Button>
      </div>
    </div>
  )
}
export const renderLeftSide = (props) => {
  const {
    getCurrentImageList,
    setCurrentImageList,
    getOverAllImageList,
    setOverAllImageList,
    getCurrentStorageItem,
    setCurrentStorageItem,
    getInitLoad,
    setInitLoad,
    setStorageUnitId,
    getStorageUnitId,
    setSelectedItem,
    isRerender,
    setRerender,
    storageGridTableData,
    setStorageGridTableData,
    getVendorId,
  } = props
  return (
    <div className="cls-swap-left-panel">
      <DigitTable
        getRawList={(props) => {
          setCurrentStorageItem([])
        }}
        getInitLoad={getInitLoad}
        setInitLoad={setInitLoad}
        currentList={getCurrentStorageItem}
        setStorageUnitId={setStorageUnitId}
        getStorageUnitId={getStorageUnitId}
        isRerender={isRerender}
        setRerender={setRerender}
        setSelectedItem={setSelectedItem}
        storageGridTableData={storageGridTableData}
        setStorageGridTableData={setStorageGridTableData}
        getVendorId={getVendorId}
        onUpdate={(innerProps) => {
          const { data = [], raw = [] } = innerProps
          const [_data = {}] = data
          let lcData = raw.filter((itm) => itm.isConnected)
          lcData = lcData.map((itm) => itm.storage_unit_id)
          setCurrentImageList([])
          setCurrentStorageItem([...lcData])
        }}
      />
    </div>
  )
}

let renderImageHeaderLeftSearch = (props) => {
  const { getSearchImage = "", setSearchImage, setTriggerSearchImag } = props

  const selectAllBtnAttr = {
    variant: "contained",
    color: "primary",
    onClick: () => { },
    className: `cls-header-left-kit`,
  }
  return (
    <div>
      <TextField
        style={{ marginRight: 10 }}
        inputProps={{
          style: {
            height: "23px",
            minHeight: "23px",
            minWidth: 260,
            padding: 6,
          },
        }}
        variant="outlined"
        placeholder="Search by Product Name/Barcode/SKU"
        onChange={(e, val) => {
          let value = e.target.value
          setSearchImage(value.length > 3 ? value : "")
        }}
      />
    </div>
  )
}
let renderImageHeaderRightSelect = (props) => {
  const {
    setCurrentImageList,
    getOverAllImageList,
    getCurrentImageList,
    getSelectedItem,
    setSelectedItem,
    clickedSelectAll
  } = props
  const selectAllBtnAttr = {
    variant: "outlined",
    onClick: clickedSelectAll,
  }
  return (
    <div className="cls-swap-right-header">
      <Adm.Button {...selectAllBtnAttr}>{"Select All"}</Adm.Button>
      <div style={{ padding: 10, fontWeight: "bold" }}>{`${getSelectedItem.length || 0} Selected`}</div>
      {getSelectedItem.length > 0 && (
        <div
          style={{
            padding: 10,
            fontWeight: "bold",
            cursor: "pointer",
            textDecoration: "underline",
          }}
          onClick={() => {
            clickedSelectAll(false)
          }}
        >{`Clear All`}</div>
      )}
    </div>
  )
}
let renderImageListHeader = (props) => {
  const {
    setCurrentImageList,
    getOverAllImageList,
    getCurrentImageList,
  } = props
  const selectAllBtnAttr = {
    variant: "outlined",
    onClick: () => setCurrentImageList([...getOverAllImageList]),
  }
  return (
    <div
      style={{
        display: "flex",
        marginLeft: 10,
        alignItems: "center",
        justifyContent: "space-between",
      }}
    >
      {renderImageHeaderLeftSearch(props)}
      {renderImageHeaderRightSelect(props)}
    </div>
  )
}
export const renderRightSide = (props) => {
  const {
    getCurrentImageList,
    setCurrentImageList,
    getOverAllImageList,
    setOverAllImageList,
    getCurrentStorageItem,
    getSearchImage,
    getStorageUnitId,
    getVendorId,
    setSelectedItem,
    productGridTableData,
    setProductGridTableData,
  } = props

  return (
    <div
      className={`cls-swap-right-panel ${getCurrentImageList.length > 0 ? "cls-selected-list" : ""
        }`}
    >
      <div className="cls-swap-right-sub-panel">
        {getCurrentStorageItem.length > 0 ? (
          <>
            {renderImageListHeader(props)}
            <DigitImageTable
              searchTrigger={getSearchImage}
              refreshList={getCurrentStorageItem}
              currentList={getCurrentImageList}
              getStorageUnitId={getStorageUnitId}
              getVendorId={getVendorId}
              setSelectedItem={setSelectedItem}
              productGridTableData={productGridTableData}
              setProductGridTableData={setProductGridTableData}
              getRawList={(props) => {
                let lcData = props?.data.map((itm) => itm.storage_unit_id)
                setOverAllImageList([...lcData])
              }}
              onUpdate={(innerProps) => {
                const { data = [], raw = [] } = innerProps
                const [_data = {}] = data
                let lcData = raw.filter((itm) => itm.isConnected)
                lcData = lcData.map((itm) => itm.storage_unit_id)
                setCurrentImageList([...lcData])
              }}
            />
          </>
        ) : (
          <div style={EmptyProductImage}>
            <div><VendorSwaperLens /></div>
            <div style={EmptyProductStyles}>Select the storage to view products</div>
          </div>
        )}
      </div>
    </div>
  )
}
